import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Button from "../../commons/button";
import Input from "../../commons/input";
import Select from "../../commons/select";
import ReactPlayer from "react-player";
import _ from "lodash";
import ContactDetails from "../../commons/contact-details";
import { device } from "../../../screens";
import CheckCircleSVG from "assets/svg/check-circle-preview";
import PowerByIconSVG from "assets/svg/powered-by-icon";
import ContactsContainer from "../../commons/contact-container";
import CCIconLogoContainer from "../../commons/cc-logo-container";
import FormContainer from "../../commons/form-container";
import HeaderTemplate from "../../commons/header-template";
import { sanitizeValueHTML } from "utils/constant";

const FormResponsive = styled.div`
  width: 100%;
  margin-bottom: 6px;
  display: grid;
  row-gap: 6px;
  column-gap: 12px;

  @media ${device.xs} {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  @media (min-width: 1${({ responsive }) => responsive + 1}px) {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
`;
const TicksItem = styled.div`
  width: 100%;
  display: inline-flex;
  column-gap: 10px;

  margin-top: 24px;

  ${({ hidden }) => (hidden ? `display: none;` : "")}

  @media ${device.xs} {
    column-gap: 13px;
  }

  @media (min-width: 1${({ responsive }) => responsive + 1}px) {
    margin-top: 28px;
  }
`;
const ImageContainer = styled.div`
  position: relative !important;
  display: grid !important;
  width: 100% !important;
  ${({ isVideo }) => isVideo && "padding-top: 10px;"}

  margin-top: 24px;

  @media (min-width: 1${({ responsive }) => responsive + 1}px) {
    margin-top: 28px;
  }
`;
const TicksText = styled.p`
  margin: 0;

  letter-spacing: -0.01em;
  font-feature-settings:
    "pnum" on,
    "lnum" on;
  color: #474747;

  letter-spacing: -0.01em;
  font-feature-settings:
    "pnum" on,
    "lnum" on;
  color: #474747;

  font-size: 14px;
  line-height: 17px;

  @media (min-width: 1${({ responsive }) => responsive + 1}px) {
    font-size: 16px;
    line-height: 19px;
  }
`;
const BtnContainer = styled.div`
  width: 100%;
  margin-top: 12px;

  @media ${device.xs} {
    margin-top: 24px;
  }

  @media (min-width: 1${({ responsive }) => responsive + 1}px) {
    margin-top: 28px;
  }
`;
const BtnText = styled.p`
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
`;

const Image = styled.img`
  object-fit: fill;
  width: 100%;
  height: 100%;
`;

const LeadMagnet = ({ data }) => {
  const [playing, setPlaying] = useState(false);
  useEffect(() => {
    if (!data.overlay) {
      setPlaying(false);
    }
  }, [data.overlay]);

  return (
    <>
      <div style={{ width: "100%", height: "100%" }}>
        <HeaderTemplate
          family={data.font?.family}
          width={data.width}
          dangerouslySetInnerHTML={{ __html: sanitizeValueHTML(data.title) }}
          contacts={true}
        />
        <ContactsContainer>
          <ContactDetails data={data} />
          <FormContainer responsive={data.width}>
            <FormResponsive responsive={data.width}>
              {data.show_name && (
                <Input
                  responsive={data.width}
                  label={
                    data.name_input_label ? data.name_input_label : "First Name"
                  }
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Name"
                />
              )}
              {data.show_email_address && (
                <Input
                  responsive={data.width}
                  label={
                    data.email_input_label
                      ? data.email_input_label
                      : "Email Address"
                  }
                  id="email"
                  type="text"
                  name="email"
                  placeholder="Email Address"
                />
              )}
              {data.show_phone && (
                <Input
                  responsive={data.width}
                  label={
                    data.phone_input_label ? data.phone_input_label : "Phone"
                  }
                  type="text"
                  id="phone"
                  name="phone"
                  placeholder="Phone"
                />
              )}
              {data.show_enquiry_type && (
                <Select
                  responsive={data.width}
                  label={
                    data.enquiry_input_label
                      ? data.enquiry_input_label
                      : "Enquiry Type"
                  }
                  name="enquiry"
                  id="enquiry"
                  placeholder="Enquiry Type"
                />
              )}
            </FormResponsive>
            <BtnContainer responsive={data.width}>
              {data.submit_button.text && (
                <Button
                  responsive={data.width}
                  display={
                    !data.submit_button.visible ? "none" : "inline-block"
                  }
                  background={data?.button_colour || "black"}
                  family={data.font?.family}
                  radius={data?.button_corner_style}
                  color={data?.button_font_colour}
                  type="submit"
                >
                  <BtnText>{data.submit_button.text}</BtnText>
                </Button>
              )}
            </BtnContainer>
            {(!_.isEmpty(data?.image_url) || !_.isEmpty(data?.video_link)) && (
              <ImageContainer
                responsive={data.width}
                isVideo={!!data?.video_link}
              >
                {data?.video_link && (
                  <ReactPlayer
                    url={data.video_link}
                    playing={playing}
                    onPlay={() => setPlaying(true)}
                    controls
                    width="100%"
                    height="300px"
                    css={{
                      position: `absolute`,
                      width: "100%",
                      height: "300px",
                      top: 0,
                      left: 0,
                    }}
                  />
                )}
                {data?.image_url && (
                  <Image src={data.image_url} alt={data.image_key} />
                )}
              </ImageContainer>
            )}
            {!_.isEmpty(data.text.value) && (
              <TicksItem hidden={!data.text.visible} responsive={data.width}>
                {data.show_ticks && !_.isEmpty(data.text.value) && (
                  <div>
                    <CheckCircleSVG
                      color={data?.button_colour || "#808080"}
                      responsive={data.width}
                    />
                  </div>
                )}
                <TicksText responsive={data.width}>{data.text.value}</TicksText>
              </TicksItem>
            )}
          </FormContainer>
        </ContactsContainer>
      </div>
      {data?.show_logo && (
        <CCIconLogoContainer>
          <PowerByIconSVG />
        </CCIconLogoContainer>
      )}
    </>
  );
};

export default LeadMagnet;
